// Implements: F-UIX-019
/**
 * The platform totals as a table: one row per organization (the rows are its children,
 * each mounted by its own container), the conditional "No organization" row, and the
 * overall total in the footer. The columns are organization level only: there is no
 * team, person or mockup column to fill (UIX.8).
 */

import type { ReactElement, ReactNode } from "react";

import { useTranslation } from "../../../shared/i18n";
import type { RowFigures } from "../model/platformRows";
import styles from "./PlatformTotals.module.css";
import { FigureCells } from "./TotalsRow";

export interface TotalsTableProps {
  readonly total: RowFigures;
  readonly children: ReactNode;
}

export function TotalsTable({ total, children }: TotalsTableProps): ReactElement {
  const { t } = useTranslation();
  return (
    <div className={styles.scroll}>
      <table className={styles.table} aria-label={t("admin.totals.tableLabel")}>
        <thead>
          <tr>
            <th scope="col">{t("admin.totals.organization")}</th>
            <th scope="col">{t("admin.totals.delivered")}</th>
            <th scope="col">{t("admin.totals.failed")}</th>
            <th scope="col">{t("admin.totals.cancelled")}</th>
            <th scope="col">{t("admin.totals.tokens")}</th>
            <th scope="col">{t("admin.totals.cost")}</th>
            <th scope="col">{t("admin.totals.detail")}</th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
        <tfoot>
          <tr>
            <th scope="row">{t("admin.totals.total")}</th>
            <FigureCells figures={total} />
            <td />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
